// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader__1mIgT"};